define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../models/CustomerPlanModel", "../../models/CustomerPlanItemModel", "../../models/UserContext"], function (require, exports, $, ko, log, tools, KendoUtils, DateUtils, CustomerPlanModel, CustomerPlanItemModel, UserContext) {
    "use strict";
    var CustomerPlans = /** @class */ (function () {
        function CustomerPlans() {
            this.userCanViewCustomerPlans = ko.observable(UserContext.hasAccess("Admin,CustomerPlans.View,CustomerPlans.Edit,CustomerPlans.Delete"));
            this.userCanEditCustomerPlans = ko.observable(UserContext.hasAccess("Admin,CustomerPlans.Edit,CustomerPlans.Delete"));
            this.userCanDeleteCustomerPlans = ko.observable(UserContext.hasAccess("Admin,CustomerPlans.Delete"));
            this.editModel = ko.observable(new CustomerPlanModel());
            this.editItemModel = ko.observable(new CustomerPlanItemModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
            this.filteredServiceTypes = ko.observableArray([]);
            this.filteredProductTypes = ko.observableArray([]);
            this.filteredPlans = ko.observableArray([]);
            this.expandedItemIDs = [];
        }
        CustomerPlans.prototype.init = function (customerId, readyCallback) {
            var self = this;
            self.customerId = customerId;
            tools.ajaxGet({
                url: "/CustomerPlans/GetPlansLookupData",
                data: { customerId: self.customerId },
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.customerName = data.Data.Name;
                        var gridStructure = self.lookupLists.GridStructures.PlanItemsStructure;
                        var columns = gridStructure.columns;
                        columns.push({
                            field: "",
                            title: "",
                            width: "100px",
                            sortable: false,
                            template: function (dataItem) {
                                var html = "";
                                if (dataItem.Id > 0) {
                                    if (self.userCanEditCustomerPlans()) {
                                        html += '<a class="btn btn-sm btn-info btn-edit-item" href="#"><i class="fa fa-edit "></i>&nbsp;</a>';
                                    }
                                    if (self.userCanDeleteCustomerPlans()) {
                                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove-item" href="#"><i class="fa fa-trash-o "></i>&nbsp;</button>';
                                    }
                                }
                                return html;
                            }
                        });
                        self.initPlans();
                        self.filterProductServiceTypes();
                        if (readyCallback) {
                            readyCallback();
                        }
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        CustomerPlans.prototype.initPlans = function () {
            var self = this;
            var gridId = "divCustomerPlansTable";
            var gridStructure = self.lookupLists.GridStructures.PlansStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "165px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (dataItem.Id > 0) {
                        if (self.userCanEditCustomerPlans()) {
                            html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>&nbsp;</a>';
                            html += '&nbsp;<a class="btn btn-sm btn-info btn-add" href="#"><i class="fa fa-plus "></i>&nbsp;New Item</a>';
                        }
                        if (self.userCanDeleteCustomerPlans()) {
                            html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>&nbsp;</button>';
                        }
                    }
                    return html;
                }
            });
            self.plansTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerPlans/GetCustomerPlans",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.customerId = self.customerId;
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($("#plans-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    //rowTemplate: kendo.template($("#customerePlanRowTemplate").html()),
                    detailInit: self.initPlanItems.bind(self),
                    dataBound: function (e) {
                        self.clearFilterInProgress = false;
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.contains(self.expandedItemIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.contains(self.expandedItemIDs, rowData.Id)) {
                            self.expandedItemIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedItemIDs.length; i++) {
                            if (self.expandedItemIDs[i] === rowData.Id)
                                self.expandedItemIDs.splice(i, 1);
                        }
                    }
                },
                enableExport: {
                    entityName: "Plans",
                    title: "Plan Records",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false,
                controller: self
            };
            self.plansTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                if (!self.clearFilterInProgress) {
                    self.plansTable.refresh();
                }
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editPlan(data.Id);
                event.preventDefault();
            }).on("click", ".btn-add", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editPlanItem(data.Id, undefined);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deletePlanConfirm(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove-item", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deletePlanItemConfirm(data.Id);
                event.preventDefault();
            }).on("click", ".btn-edit-item", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editPlanItem(data.CallPlanId, data.Id);
                event.preventDefault();
            });
        };
        CustomerPlans.prototype.initPlanItems = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.PlanItemsStructure;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    data: e.data.CustomerPlanItems,
                    serverPaging: false,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 100,
                    schema: {
                        model: gridStructure.model
                    }
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (event) {
                }
            }).data("kendoGrid");
        };
        CustomerPlans.prototype.filterProductServiceTypes = function () {
            var self = this;
            self.filteredServiceTypes(ko.utils.arrayFilter(self.lookupLists.ServiceTypes, function (item) {
                if (self.editModel().ProviderId() > 0) {
                    return item.ProviderId === self.editModel().ProviderId();
                }
                else {
                    return true;
                }
            }));
            self.filteredProductTypes(ko.utils.arrayFilter(self.lookupLists.ProductTypes, function (item) {
                if (self.editModel().ProviderId() > 0) {
                    return item.Providers.indexOf(self.editModel().ProviderId()) > -1;
                }
                else {
                    return true;
                }
            }));
            self.filteredPlans(ko.utils.arrayFilter(self.lookupLists.Plans, function (item) {
                if (self.editModel().ProviderId() > 0) {
                    return item.ProviderId === self.editModel().ProviderId();
                }
                else {
                    return true;
                }
            }));
        };
        CustomerPlans.prototype.exportTo = function () {
            var self = this;
            self.plansTable.exportTo();
        };
        CustomerPlans.prototype.clearFilter = function () {
            var _this = this;
            var self = this;
            self.clearFilterInProgress = true;
            self.filterByAny("");
            setTimeout(function () {
                _this.plansTable.refresh();
            }, 201);
        };
        CustomerPlans.prototype.deletePlanConfirm = function (planId) {
            var _this = this;
            tools.confirmModal({
                title: "Delete Plan",
                text: "Are you sure you want to delete Plan?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.deletePlan(planId);
            });
        };
        CustomerPlans.prototype.deletePlan = function (planId) {
            var _this = this;
            var data = {
                id: planId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerPlans/DeletePlanConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Plan deleted successfully");
                    _this.plansTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerPlans.prototype.deletePlanItemConfirm = function (planItemId) {
            var _this = this;
            tools.confirmModal({
                title: "Delete Plan Item",
                text: "Are you sure you want to delete Plan Item?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.deletePlanItem(planItemId);
            });
        };
        CustomerPlans.prototype.deletePlanItem = function (planItemId) {
            var _this = this;
            var data = {
                id: planItemId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerPlans/DeletePlanItemConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Plan Item deleted successfully");
                    _this.plansTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerPlans.prototype.editPlan = function (planId) {
            var self = this;
            var title = "Add New Plan";
            if (!isNaN(planId)) {
                title = "Edit Customer Plan";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().CallPlanId() || self.editModel().CallPlanId() <= 0) {
                        tools.error("Plan is required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.savePlan(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(planId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerPlans/GetPlanById",
                            data: { id: planId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerPlanModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerPlanModel());
                        self.editModel().CustomerId(self.customerId);
                        self.editModel().CustomerName(self.customerName);
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-plan-edit-template', data: editModel }\"></div>");
                        self.editModel().ProviderId.subscribe(function () {
                            self.filterProductServiceTypes();
                        });
                        self.filterProductServiceTypes();
                        self.editModel().CallPlanId.subscribe(function () {
                            var plan = ko.utils.arrayFirst(self.lookupLists.Plans, function (item) {
                                return self.editModel().CallPlanId() === item.Value;
                            });
                            if (plan) {
                                self.editModel().ProductTypeId(plan.ProductTypeId);
                                self.editModel().ServiceTypeId(plan.ServiceTypeId);
                            }
                            else {
                                self.editModel().ProductTypeId(0);
                                self.editModel().ServiceTypeId(0);
                            }
                        });
                        self.editModel().PlanTermType.subscribe(function (value) {
                            if (!self.editModel().PlanTermStartDate()) {
                                self.editModel().PlanTermStartDate(DateUtils.today());
                            }
                            if (value && value != 99) {
                                var startDate = self.editModel().PlanTermStartDate();
                                var endDate = DateUtils.addMonths(startDate, value * 12);
                                self.editModel().PlanTermEndDate(endDate);
                            }
                        });
                        self.editModel().PlanTermStartDate.subscribe(function (value) {
                            var termType = self.editModel().PlanTermType();
                            if (value && termType && termType != 99) {
                                var endDate = DateUtils.addMonths(value, termType * 12);
                                self.editModel().PlanTermEndDate(endDate);
                            }
                        });
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerPlans.prototype.savePlan = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = tools.modelToFormData(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerPlans/SaveCustomerPlan",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.plansTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerPlans.prototype.editPlanItem = function (planId, planItemId) {
            var self = this;
            var title = "Add New Plan Item";
            if (!isNaN(planItemId)) {
                title = "Edit Plan Item";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editItemModel().Name()) {
                        tools.error("Plan Item Name is required");
                        return;
                    }
                    if (self.multipleCallTypesSelector.value().length === 0) {
                        tools.error("Call Type is required");
                        return;
                    }
                    if (!self.editItemModel().RateType()) {
                        tools.error("Rate Type is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.savePlanItem(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(planItemId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerPlans/GetPlanItemById",
                            data: { id: planItemId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editItemModel(new CustomerPlanItemModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editItemModel(new CustomerPlanItemModel());
                        self.editItemModel().CustomerCallPlanId(planId);
                        self.editItemModel().CustomerId(self.customerId);
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'plan-item-edit-template', data: editItemModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.multipleCallTypesSelector = $("#callTypes", modal).kendoMultiSelect({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select call types...",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            autoClose: false,
                            dataSource: {
                                data: self.lookupLists.CallTypes
                            }
                        }).data("kendoMultiSelect");
                        self.multipleCallTypesSelector.value(self.editItemModel().CallTypes());
                        self.multipleAdditionalCallTypesSelector = $("#additionalCallTypes", modal).kendoMultiSelect({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select call types...",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            autoClose: false,
                            dataSource: {
                                data: self.lookupLists.CallTypes
                            }
                        }).data("kendoMultiSelect");
                        self.multipleAdditionalCallTypesSelector.value(self.editItemModel().AdditionalCallTypes());
                    });
                }
            });
        };
        CustomerPlans.prototype.savePlanItem = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editItemModel);
            obj.CallTypesStr = self.multipleCallTypesSelector.value().join();
            obj.AdditionalCallTypesStr = self.multipleAdditionalCallTypesSelector.value().join();
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerPlans/SavePlanItem",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.plansTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerPlans.prototype.contains = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        return CustomerPlans;
    }());
    return CustomerPlans;
});
//# sourceMappingURL=customerPlans.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerPlans.js
// module id = 189
// module chunks = 2